import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID, DATETIME } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'type'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      description: new STRING(),
      created_at: new STRING(),
      updated_at: new DATETIME(),
      deleted_date: new DATETIME()
    }
  }
}
